<style scoped>
	.c-panel{margin: 0px; padding: 0px 20px;}
</style>

<template>
	<el-dialog
		v-if="m"
		title="缺课登记(该页面只能登记无法取消)"
		:visible.sync="isShow"
		width="600px"
		top="25vh"
		:append-to-body="true"
		:destroy-on-close="true"
		:close-on-click-modal="false"
		custom-class="full-dialog"
		>
		<div class="vue-box">
			<div class="c-panel">
				<!-- 参数栏 -->
				<br>
				<el-form size="mini">
          <el-form-item label="课程编号：" v-show="false">
            <el-input v-model="m.clazzCardId" disabled></el-input>
          </el-form-item>
          <el-form-item label="缺课学生：">
            <el-checkbox-group v-model="m.stuId">
              <el-checkbox v-for="item in clazzStudentList"
                           :key="item.id"
                           :label="item.id"
                           :disabled="isSelected(item.id)"
                           :value="item.id" >{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
				</el-form>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="isShow = false">取 消</el-button>
			<el-button size="small" type="primary" @click="ok()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				isShow: true,
				id: 0,
				m: null,
        clazzStudentList:[],
        selectedList:[],
			}
		},
		methods: {
			// 打开
			open: function(id) {
			  let _this = this;
        this.isShow = true;
        this.m = this.createM();
        this.m.clazzCardId=id;
          this.sa.ajax('api/psdAdmin/clazzCard/getClazzCardInfoById', {id: id}, function(res) {
            if(res.code=='0'){
              this.sa.ajax('api/psdAdmin/clazz/getStudentList', {clazzId: res.data.clazzId}, function(result) {
                if(result.code=='0'){
                  _this.clazzStudentList = result.data;
                  this.sa.ajax('api/psdAdmin/absent/getAbsentInfoByClazzCardId', {clazzCardId: id}, function(resp) {
                    if(resp.code=='0'){
                      this.selectedList = resp.data;
                      for(let i=0;i<resp.data.length;i++){
                        this.m.stuId.push(resp.data[i].stuId);
                      }
                    }else{
                      _this.sa.error("学生列表获取失败请重试");
                    }
                  }.bind(this));
                }else{
                  _this.sa.error("学生列表获取失败请重试");
                }
              }.bind(this));
            }else{
              _this.sa.error("课表信息获取失败请重试");
            }
          }.bind(this));
			},
			// 表单验证
			submit_check: function() {
				var m = this.m;
				var sa = this.sa;
				if(sa.isNull(m.stuId) || m.stuId.length<=0) {
					return sa.error('你必须至少选择一个学生');
				}
				return 'ok';
			},
			// 提交
			ok: function() {
				// 表单验证
				if(this.submit_check() != 'ok') {
					return;
				}
				console.log('提交数据',this.m);

				// 开始增加或修改
				let self = this;
        // id != 0 为修改
        this.sa.ajax('api/psdAdmin/absent/addAbsentInfo',
            JSON.stringify(this.m), function(res){
          if(res.code == '0') {
            self.sa.alert('学生缺课信息登记成功', function () {
              self.$parent.f5();	// 父视图刷新
              self.isShow = false;
            });
          }else{
            this.sa.error(res.msg || '学生缺课信息登记失败');
          }
        },{ contentType:"application/json;charset=UTF-8"});
      },
      createM:function (){
        return {
          stuId:[],
          clazzCardId:'',
        }
      },
      isSelected(id){
        for(let i=0;i<this.selectedList.length;i++){
          if(id==this.selectedList[i].stuId){
            return true;
          }
        }
        return false;
      }
		},
		created: function(){

		}
	}
</script>
